import React from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Page,
  Sort,
} from "@syncfusion/ej2-react-grids";
import { Box, Typography, IconButton } from "@mui/material";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";

interface PhysicianGroupMember {
  id: string;
  code: string;
  firstName: string;
  lastName: string;
  centerId: string;
  centerName: string;
  specialty: string;
}

interface PhysicianGroupMembersGridProps {
  members: PhysicianGroupMember[];
  isLoading: boolean;
  onUnassign: (physicianId: string) => void;
}

export function PhysicianGroupMembersGrid({ members, isLoading, onUnassign }: PhysicianGroupMembersGridProps) {
  const actionTemplate = (props: { id: string }) => (
    <IconButton size="small" title="Unassign" onClick={() => onUnassign(props.id)}>
      <PersonRemoveIcon fontSize="small" color="error" />
    </IconButton>
  );

  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  if (members.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 8 }}>
        <Typography variant="h6" sx={{ color: "#64748b", mb: 1 }}>
          No physicians assigned
        </Typography>
        <Typography variant="body2" sx={{ color: "#94a3b8" }}>
          Use "Assign Physician" to add members to this group.
        </Typography>
      </Box>
    );
  }

  return (
    <GridComponent
      dataSource={members}
      height={400}
      allowPaging={true}
      allowSorting={true}
      pageSettings={{ pageSize: 25 }}
      style={{ border: "1px solid #e2e8f0", borderRadius: "8px", backgroundColor: "#ffffff" }}
      enableHover={true}
    >
      <ColumnsDirective>
        <ColumnDirective field="code" headerText="Code" width="120" textAlign="Left" />
        <ColumnDirective field="lastName" headerText="Last Name" width="150" textAlign="Left" />
        <ColumnDirective field="firstName" headerText="First Name" width="150" textAlign="Left" />
        <ColumnDirective field="centerName" headerText="Center" width="120" textAlign="Left" />
        <ColumnDirective field="specialty" headerText="Specialty" width="150" textAlign="Left" />
        <ColumnDirective
          headerText="Actions"
          width="90"
          textAlign="Center"
          template={actionTemplate}
        />
      </ColumnsDirective>
      <Inject services={[Page, Sort]} />
    </GridComponent>
  );
}
